exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yc-spin {\n  -webkit-animation: yc-spin 2s infinite linear;\n          animation: yc-spin 2s infinite linear;\n}\n\n.yc-pulse {\n  -webkit-animation: yc-spin 1s infinite steps(8);\n          animation: yc-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes yc-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n\n@keyframes yc-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/@ycgame/icons/animated.css
// module id = 36
// module chunks = 1